export default __webpack_public_path__ + "static/media/Admglobales.a064a7db.png";